import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  ADD_THANK_YOU,
  EDIT_THANK_YOU,
  LIST_THANK_YOU,
  VIEW_THANK_YOU,
  DELETE_THANK_YOU,

} from "./actionTypes"
import { thankYouSuccess, thankYouError } from "./actions"


import {
  onAddThankYou,
  onEditThankYou,
  onListThankYou,
  onViewThankYou,
  onSortThankYou,
  onDeleteThankYou,

} from "helpers/backend_api_helper";

// add ThankYou
function* addThankYou({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddThankYou, data);
    yield put(thankYouSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(thankYouError(error?.response?.data?.message || "Server Error"));
  }
}

// edit ThankYou
function* editThankYou({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditThankYou, data, id);
    yield put(thankYouSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(thankYouError(error?.response?.data?.message || "Server Error"));
  }
}

// list ThankYou
function* listThankYou({ payload: { data, callback } }) {
  try {
    const response = yield call(onListThankYou, data);
    yield put(thankYouSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(thankYouError(error?.response?.data?.message || "Server Error"));
  }
}

// view ThankYou
function* viewThankYou({ payload: { data, history } }) {
  try {
    const response = yield call(onViewThankYou, data);
    yield put(thankYouSuccess(response));

  } catch (error) {
    yield put(thankYouError(error?.response?.data?.message || "Server Error"));
  }
}

// delete ThankYou
function* deleteThankYou({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteThankYou, data);
    yield put(thankYouSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(thankYouError(error?.response?.data?.message || "Server Error"));
  }
}



function* configThankYouSaga() {
  yield takeEvery(ADD_THANK_YOU, addThankYou);
  yield takeEvery(EDIT_THANK_YOU, editThankYou);
  yield takeEvery(LIST_THANK_YOU, listThankYou);
  yield takeEvery(VIEW_THANK_YOU, viewThankYou);
  yield takeEvery(DELETE_THANK_YOU, deleteThankYou);
}

export default configThankYouSaga;

